import sdl from '@jds/react-generated-sdl/JDSDatepickerMobile';
import type { JDSDatepickerMobileProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DatePickerProps } from '../logic';

const Component = (props: DatePickerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'default',
    open = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, open, ...rest },
    'JDSDatepickerMobile',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerMobile = withLogic(Component) as React.FC<DatePickerProps> & {
  slotName?: string;
};

DatepickerMobile.displayName = 'DatepickerMobile';
DatepickerMobile.slotName = 'jds_datepicker_mobile';

export { DatepickerMobile, type JDSDatepickerMobileProps };
